import { render, staticRenderFns } from "./ClientDownloadBox.vue?vue&type=template&id=68226128&scoped=true"
import script from "./ClientDownloadBox.vue?vue&type=script&lang=js"
export * from "./ClientDownloadBox.vue?vue&type=script&lang=js"
import style0 from "./ClientDownloadBox.vue?vue&type=style&index=0&id=68226128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68226128",
  null
  
)

export default component.exports